<div>
	<div class="text-center">
		<h4>Are you sure you want to cancel order?</h4>
		<p *ngIf="state">
			You will be taken to the FCT portal to complete this process.
		</p>
		<p *ngIf="!state">All details tied to your active order will be lost.</p>
	</div>

	<div class="flex justify-center items-center mt-5 gap-4">
		<app-button btn="tertiary" (click)="close()" size="small">No</app-button>
		<app-button btn="primary" (click)="cancel()" size="small">Yes</app-button>
	</div>
</div>
